import MaterialButton from '@mui/material/Button'
import { useRouter } from 'next/router'
import React from 'react'
import useI18n from '../../lib/hooks/useI18n'
import Button from '../Button'
import styles from './index.module.css'

const SignInForm = () => {
  const { i18n } = useI18n()
  const router = useRouter()

  return (
    <div className={styles['container']}>
      <div className={styles['sign-in-text']}>{i18n.siroBlue}</div>
      <Button label={i18n.signIn}></Button>
    </div>
  )
}

export default SignInForm
